// iter 275 round 46 — Feedback rating su foto live.
//
// Bottoni "buona" / "non buona" fine, niente colori, niente badge.
// Solo per items live (Migliora / Arreda / Restyle / Pianta).
//
// Stato:
//   null     → utente non si è ancora espresso (entrambi i bottoni grigi)
//   +1       → "buona" attivo (icona bianca su circle scuro)
//   -1       → "non buona" attivo (idem)
//
// Le foto positive verranno usate come esempio few-shot per le future
// generazioni della stessa tipologia di stanza (vedi live_feedback.py).

import React, { useEffect, useState } from "react";
import { ThumbsUp, ThumbsDown } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export function LiveFeedbackBar({ liveId, isLive }) {
  const [rating, setRating] = useState(null);
  const [busy, setBusy] = useState(false);

  // Load saved rating (best-effort, no UI feedback se fallisce).
  useEffect(() => {
    if (!isLive || !liveId) return;
    let on = true;
    api
      .get(`/live/${liveId}/feedback`)
      .then((r) => { if (on) setRating(r.data?.rating ?? null); })
      .catch(() => { /* silent */ });
    return () => { on = false; };
  }, [liveId, isLive]);

  if (!isLive || !liveId) return null;

  const submit = async (next) => {
    if (busy) return;
    const optimistic = rating === next ? null : next; // re-tap = annulla
    setRating(optimistic);
    if (optimistic === null) return; // niente da inviare al backend in caso di annullo? lo lascio comunque, può rifare un click
    setBusy(true);
    try {
      await api.post(`/live/${liveId}/feedback`, { rating: optimistic });
    } catch {
      // rollback
      setRating(rating);
    } finally {
      setBusy(false);
    }
  };

  const Btn = ({ value, Icon, label }) => {
    const active = rating === value;
    return (
      <button
        type="button"
        onClick={() => submit(value)}
        disabled={busy}
        aria-label={label}
        title={label}
        className={`w-9 h-9 rounded-full inline-flex items-center justify-center transition-all ${
          active
            ? "bg-white text-[#1C1C1A]"
            : "text-white/70 hover:text-white hover:bg-white/10"
        }`}
        data-testid={`feedback-${value === 1 ? "up" : "down"}`}
      >
        <Icon size={15} weight={active ? "fill" : "regular"} />
      </button>
    );
  };

  return (
    <div
      className="inline-flex items-center gap-1 px-1 py-1 rounded-full border border-white/15"
      data-testid="live-feedback-bar"
    >
      <Btn value={1} Icon={ThumbsUp} label="Foto buona" />
      <Btn value={-1} Icon={ThumbsDown} label="Non funziona" />
    </div>
  );
}
